import {
    $createRangeSelection,
    $createTextNode,
    $getSelection,
    $isRangeSelection,
    LexicalEditor
} from "lexical"

const debug = false
// const debug = "lexicalAddText"

export function lexicalAddText(editor: LexicalEditor, text:string) {
    editor.update(() => {
        let selection = $getSelection()
        if (!$isRangeSelection(selection)) selection = $createRangeSelection()

        debug && console.log(debug, 'update', $isRangeSelection(selection), selection)

        const textNode = $createTextNode(text)
        selection.insertNodes([textNode])
    })
}